export default function formatAMPM(date, shortDay) {
  const formatedTime = date.toLocaleString('en-US', {
    weekday: shortDay ? 'short' : 'long', // long, short, narrow
    day: 'numeric', // numeric, 2-digit
    year: 'numeric', // numeric, 2-digit
    month: 'long', // numeric, 2-digit, long, short, narrow
    hour: 'numeric', // numeric, 2-digit
    minute: 'numeric' // numeric, 2-digit
  })
  return formatedTime
}
export function getDayMonth(date) {
  const dateObject = new Date(date)
  const formatedTime = dateObject.toLocaleString('en-US', {
    day: 'numeric', // numeric, 2-digit
    month: 'short' // numeric, 2-digit, long, short, narrow
  })
  return formatedTime
}
export function TimeFormat(duration) {
  // Hours, minutes and seconds
  let hrs = ~~(duration / 3600)
  let mins = ~~((duration % 3600) / 60)
  let secs = ~~duration % 60
  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = ''
  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
  }
  ret += '' + mins + ':' + (secs < 10 ? '0' : '')
  ret += '' + secs
  return ret
}
